import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useCallback } from 'react';

import { type QueryStateSchema, queryParam, queryStateParser } from './queryStateParser';

const QS_TYPE: QueryStateSchema['type'] = 'districtTemplates';

/** Opens the district templates management pane. */
export const useOpenDistrictTemplatesPane = (): (() => void) => {
  const [, setState] = useQueryState(queryParam, queryStateParser);

  return useCallback(() => {
    void setState((previousState) => {
      if (previousState?.some((entry) => entry.type === QS_TYPE)) {
        return previousState;
      }
      return [
        ...(previousState || []),
        {
          id: 'district-templates',
          key: nanoid(),
          type: QS_TYPE,
        },
      ];
    });
  }, [setState]);
};
